<template>
  <table>
  <tr v-if="conditions.is_self_run !== undefined">
    <th><span>公道を自力で自走できますか？1</span></th>
    <td>
      <span>{{ yesNoFumeiJson[conditions.is_self_run] }}</span>
    </td>
  </tr>
  <tr v-if="conditions.is_studless !== undefined">
    <th><span>(冬期)スタッドレスタイヤ装着済です</span></th>
    <td>
      <span>{{ yesNoFumeiJson[conditions.is_studless] }}</span>
    </td>
  </tr>
</table>
</template>

<script>
import Mixin from '../mixin/Mixin';
export default {
  name: 'ConfirmSyaryoConditions',
  props: {
    conditions: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [Mixin],
}
</script>

<style lang="sass" scoped>
@import '../../assets/css/logico2'
th
  background: $baseBlueColor
  color: #fff
  width: 32%
td
  width: 68%
section#trial-calc
  margin: 20px auto
  background: $baseGrayColor
  border: 5px solid $baseBlueColor
  .result-message
    font-size: 24px
  @include sp
    width: 95%
    .result-message
      font-size: 15px
</style>



// WEBPACK FOOTER //
// src/components/order/ConfirmSyaryoConditions.vue